"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const recoil_1 = require("recoil");
const settingPCCStates_1 = require("./settingPCCStates");
const api_1 = require("@/api");
const errors_1 = require("@/common/errors");
const _1 = require(".");
function default_1({ default_delivery, settingPCCForm, }) {
    const { handleSubmit, setError } = settingPCCForm;
    const setIsPCCValid = (0, recoil_1.useSetRecoilState)(settingPCCStates_1.isPCCValidState);
    const validatePCC = () => setIsPCCValid(true);
    const [isVerifyPCCPending, setIsVerifyPCCPending] = (0, recoil_1.useRecoilState)(settingPCCStates_1.isVerifyPCCPendingState);
    return handleSubmit((inputData) => __awaiter(this, void 0, void 0, function* () {
        const { name, phone } = default_delivery;
        const hasNameAndPhone = Boolean(name) && Boolean(phone);
        if (!hasNameAndPhone) {
            setError('second_customvalue', {
                type: 'address',
                message: _1.pCCErrorMessages.address(),
            });
        }
        else if (!isVerifyPCCPending) {
            setIsVerifyPCCPending(true);
            const data = {
                name: name.replace(/\s/g, ''),
                phone: phone.replace(/[^0-9]/g, ''),
                second_customvalue: inputData.second_customvalue,
            };
            yield (0, api_1.postData)('/api/v1/members/verify-custom-code', data)
                .then(validatePCC)
                .catch(err => {
                if (err.response.status === 400)
                    (0, _1.handleValidatePCC400Error)(err, setError);
                else if (err.response.status === 403)
                    (0, errors_1.handle403Error)(err);
                else
                    alert((0, errors_1.commonErrorMsg)());
            })
                .finally(() => setIsVerifyPCCPending(false));
        }
    }));
}
exports.default = default_1;
